import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import Handlers from '../dispatcher/Handlers';
import { ActionTypes } from '../constants/CentricConstants';

import CategoryApi from '../server/CategoryApi';

export default {

    getById: (id) => {
        const types = {
            request: ActionTypes.CATEGORY_INFO_REQUEST,
            success: ActionTypes.CATEGORY_INFO_SUCCESS,
            failure: ActionTypes.CATEGORY_INFO_FAILURE
        };

        return CentricDispatcher.dispatchAsync(CategoryApi.getById(id), types, {id});
    },

    getAll: function(params) {
        const handleSuccess = Handlers.createSuccessHandler(ActionTypes.CATEGORY_LIST);
        const handleError = Handlers.createErrorHandler(ActionTypes.CATEGORY_LIST_ERROR);

        return CategoryApi.getAll(params)
            .then(handleSuccess, handleError)
            .catch(handleError);
    },

    getAllWithCount: (params) => {
        const types = {
            success: ActionTypes.CATEGORY_LIST,
            failure: ActionTypes.CATEGORY_LIST_ERROR
        };

        return CentricDispatcher.dispatchAsync(CategoryApi.getAllWithCount(params), types, params);
    },

    getRoots: () => {
        const types = {
            request: ActionTypes.CATEGORY_ROOT_LIST_REQUEST,
            success: ActionTypes.CATEGORY_ROOT_LIST_SUCCESS,
            failure: ActionTypes.CATEGORY_ROOT_LIST_FAILURE
        };

        return CentricDispatcher.dispatchAsync(CategoryApi.getRoots(), types);
    },

    getChildren: (parentId) => {
        const types = {
            success: ActionTypes.CATEGORY_LIST,
            failure: ActionTypes.CATEGORY_LIST_ERROR
        };

        return CentricDispatcher.dispatchAsync(CategoryApi.getChildren(parentId), types, {parentId});
    },

    getAllByOrganisation: (organisationId) => {
        const types = {
            request: ActionTypes.ORGANISATION_CATEGORY_LIST_REQUEST,
            success: ActionTypes.ORGANISATION_CATEGORY_LIST_SUCCESS,
            failure: ActionTypes.ORGANISATION_CATEGORY_LIST_FAILURE
        };

        return CentricDispatcher.dispatchAsync(CategoryApi.getAllByOrganisation(organisationId), types, {organisationId});
    },

    listByMyOrganisation: (params) => {
        const types = {
            success: ActionTypes.CATEGORY_LIST,
            failure: ActionTypes.CATEGORY_LIST_ERROR
        };

        return CentricDispatcher.dispatchAsync(CategoryApi.listByMyOrganisation(params), types, {...params});
    },

    save: function(entity) {
        const handleSuccess = Handlers.createSuccessHandler(ActionTypes.CATEGORY_SAVE, ActionTypes.FORM_SUBMIT_SUCCESS);
        const handleError = Handlers.createErrorHandler(ActionTypes.CATEGORY_INFO_ERROR);

        return CategoryApi.save(entity)
            .then(handleSuccess, Handlers._handleFormError)
            .catch(handleError);
    },

    update: function(id, entity) {
        const handleSuccess = Handlers.createSuccessHandler(ActionTypes.CATEGORY_UPDATE, ActionTypes.FORM_SUBMIT_SUCCESS);
        const handleError = Handlers.createErrorHandler(ActionTypes.CATEGORY_UPDATE_ERROR);

        return CategoryApi.update(id, entity)
            .then(handleSuccess, Handlers._handleFormError)
            .catch(handleError);
    },

    delete: function(id) {
        const handleSuccess = Handlers.createSuccessHandler(ActionTypes.CATEGORY_DELETE);
        const handleError = Handlers.createErrorHandler(ActionTypes.CATEGORY_DELETE_ERROR);

        return CategoryApi.delete(id)
            .then(handleSuccess, handleError)
            .catch(handleError);
    },

    search: function(searchText) {
        const handleSuccess = Handlers.createSuccessHandler(ActionTypes.SEARCH_RESULT_RECEIVED);
        const handleError = Handlers.createErrorHandler(ActionTypes.SEARCH_ERROR);

        return CategoryApi.search(searchText)
            .then(handleSuccess, handleError);
    },

    addOrganisation: (id, organisationId) => {
        const types = {
            request: ActionTypes.CATEGORY_ORGANISATION_ADD_REQUEST,
            success: ActionTypes.CATEGORY_ORGANISATION_ADD_SUCCESS,
            failure: ActionTypes.CATEGORY_ORGANISATION_ADD_FAILURE
        };

        return CentricDispatcher.dispatchAsync(CategoryApi.addOrganisation(id, organisationId), types, {id, organisationId});
    },

    updateOrganisation: (id, organisationId, data) => {
        const types = {
            request: ActionTypes.CATEGORY_ORGANISATION_UPDATE_REQUEST,
            success: ActionTypes.CATEGORY_ORGANISATION_UPDATE_SUCCESS,
            failure: ActionTypes.CATEGORY_ORGANISATION_UPDATE_FAILURE
        };

        return CentricDispatcher.dispatchAsync(CategoryApi.updateOrganisation(id, organisationId, data), types, {id, organisationId, data});
    },

    removeOrganisation: (id, organisationId) => {
        const types = {
            request: ActionTypes.CATEGORY_ORGANISATION_REMOVE_REQUEST,
            success: ActionTypes.CATEGORY_ORGANISATION_REMOVE_SUCCESS,
            failure: ActionTypes.CATEGORY_ORGANISATION_REMOVE_FAILURE
        };

        return CentricDispatcher.dispatchAsync(CategoryApi.removeOrganisation(id, organisationId), types, {id, organisationId});
    },

};
